<template>
  <div class="wip flex-center flex wrapper section">
    404 Not Found
  </div>
</template>
